import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['mobileMenu', 'mobileMenuBtnIconOpen', 'mobileMenuBtnIconClose'];
    toggle() {
        this.mobileMenuTarget.classList.toggle('hidden');
        this.mobileMenuBtnIconOpenTarget.classList.toggle('hidden');
        this.mobileMenuBtnIconCloseTarget.classList.toggle('hidden');
    }
}
